const defaultValues = {
  contacts: {
    title: "Mr",
    gdpr: false,
  },
};

export default defaultValues;
